import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';

@Injectable()
export class CustomListService extends BaseService {

  apiUrl = "CustomList.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getCustomLists(country: string, store: string, mediaType: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getCustomLists"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  getCustomListDetail(country: string, store: string, mediaType: string, listId: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getCustomListDetail"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("listId", listId),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  getCustomListTags(country: string, store: string, mediaType: string, sessionToken: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getCustomListTags"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  createCustomList(country: string, store: string, mediaType: string, sessionToken: string, listData: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "createCustomList"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("listData", listData)
    ));
  }

  editCustomList(country: string, store: string, mediaType: string, sessionToken: string, listId: string, listData: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "editCustomList"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("listId", listId),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("listData", listData)
    ));
  }

  deleteCustomList(country: string, store: string, mediaType: string, sessionToken: string, listId: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "deleteCustomList"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("listId", listId),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  cloneCustomList(country: string, store: string, mediaType: string, sessionToken: string, listId: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "cloneCustomList"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("listId", listId),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  likeCustomList(country: string, store: string, mediaType: string, listId: string, sessionToken: string, newStatus?: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "likeCustomList"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("listId", listId),
      new UrlParam("origin", "website")
    );

    const bodyParams = [new UrlParam("sessionToken", sessionToken)];
    if (newStatus !== undefined && newStatus !== null && newStatus !== "") {
      bodyParams.push(new UrlParam("newStatus", newStatus));
    }

    return this.post(url, this.buildUrlParams.apply(this, bodyParams));
  }

  getShareUrl(country: string, store: string, mediaType: string, sessionToken: string, listId: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getShareUrl"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("listId", listId),
      new UrlParam("origin", "website")
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  getPublicListsByTag(country: string, store: string, mediaType: string, publisher: string, limit: number, offset: number, tagIds?: string, categoryLimit?: number, categoryOffset?: number) {
    const params = [
      new UrlParam("action", "getPublicListsByTag"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("publisher", publisher),
      new UrlParam("limit", limit),
      new UrlParam("offset", offset),
      new UrlParam("origin", "website")
    ];

    if (tagIds !== undefined && tagIds !== null && tagIds !== "") {
      params.push(new UrlParam("tagIds", tagIds));
    }

    this.addCategoryPaginationParams(params, categoryLimit, categoryOffset);

    const url = this.serverUrl + this.apiUrl + this.buildUrlParams.apply(this, params);

    return this.get(url);
  }

  getPublicLists(country: string, store: string, mediaType: string, publisher: string, tagIds: string, limit: number, offset: number, sort: string, categoryLimit?: number, categoryOffset?: number) {
    const params = [
      new UrlParam("action", "getPublicLists"),
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("mediaType", mediaType),
      new UrlParam("publisher", publisher),
      new UrlParam("tagIds", tagIds),
      new UrlParam("limit", limit),
      new UrlParam("offset", offset),
      new UrlParam("sort", sort),
      new UrlParam("origin", "website")
    ];

    this.addCategoryPaginationParams(params, categoryLimit, categoryOffset);

    const url = this.serverUrl + this.apiUrl + this.buildUrlParams.apply(this, params);

    return this.get(url);
  }

  private addCategoryPaginationParams(params: Array<UrlParam>, categoryLimit?: number, categoryOffset?: number) {
    if (this.isValidCategoryLimit(categoryLimit)) {
      params.push(new UrlParam("categoryLimit", categoryLimit));
    }

    if (this.isValidCategoryOffset(categoryOffset)) {
      params.push(new UrlParam("categoryOffset", categoryOffset));
    }
  }

  private isValidCategoryLimit(value: any): boolean {
    const parsedValue = Number(value);
    return value !== undefined && value !== null && value !== "" && !isNaN(parsedValue) && parsedValue > 0;
  }

  private isValidCategoryOffset(value: any): boolean {
    const parsedValue = Number(value);
    return value !== undefined && value !== null && value !== "" && !isNaN(parsedValue) && parsedValue >= 0;
  }

}
